<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref, computed } from 'vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Head } from '@inertiajs/inertia-vue3';
import {
    mdiFormatFontSizeDecrease, mdiContrastCircle, mdiCheckCircle,
    mdiAlert,
    mdiAlertCircle,
    mdiArrowDownBold
} from '@mdi/js';
import axios from 'axios';
import NotificationBar from "@/Components/NotificationBar.vue";
import BaseIcon from "@/Components/BaseIcon.vue";

const errors = {};
const mensajes = ref([]);
const fileSubida = ref('');
const alertaSubida = ref(0);

const eventSubirArchivo = (rutaController) => {
    let formData = new FormData();
    //console.log(fileSubida.value);
    formData.append('file', fileSubida.value);
    axios.post(rutaController,
        formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    ).then(function (response) {
        //alertaSubida.value = 1;
        let respuesta = response;
        let data = respuesta.data.data;
        if (respuesta.data.success) {
            alertaSubida.value = 1;
            mensajes.value = 'Total registros : ' + (data.total - 1) + '\nRegistrados : ' + data.registered + '\nActualizados : ' + data.updated;
            limpiarVal(5000);

        } else {
            alertaSubida.value = 2;
            mensajes.value = respuesta.data.message;
            limpiarVal(3000);
        }
    }).catch(function () {
        alertaSubida.value = 2;
        limpiarVal(3000);
    });
}

const handleFileUploadArchivo = (event) => {
    //fileSubida.value = this.$refs.fileSubida.files[0];
    fileSubida.value = event.target.files[0];
    //console.log(event.target.files[0]);
}

/*const limpiarVal = computed( () => {
    if (alertaSubida.value > 0) {
        alert("hola 1")
        setTimeOut( () => {
            alert("Hola")
            fileSubida.value = '';
            mensajes.value = [];
            alertaSubida.value = 0;
        }, 3000)
    }
    
})
*/
const limpiarVal = (time) => {
    setTimeout(() => {
        fileSubida.value = '';
        mensajes.value = [];
        alertaSubida.value = 0;
    }, time)// LRR bind(this)
}


//const limpiarVal = () => {
//fileSubida.value = '';
// mensajes.value = [];
//alertaSubida.value = 0;
//}

// Alert
const notificationSettingsModel = ref([]);
const notificationsOutline = computed(
    () => notificationSettingsModel.value.indexOf("outline") > -1
);

</script>

<template>

    <Head title="Importación" />

    <BreezeAuthenticatedLayout>

        <template #header>
        <PremiumPageHeader title="Importar archivos de excel" subtitle="Gestión de importar archivos de excel">
        </PremiumPageHeader>
    </template>

        <!--<div class="py-12">
            <NotificationBar v-if="alertaSubida==4"
                color="contrast"
                :icon="mdiContrastCircle"
                :outline="notificationsOutline"
            >
                <b>Contrast</b>. NotificationBar
            </NotificationBar>
            <NotificationBar v-if="alertaSubida==1"
                color="success"
                :icon="mdiCheckCircle"
                :outline="notificationsOutline"
            >
                <b>Ok</b>. <span v-text="mensajes"></span>
            </NotificationBar>
            <NotificationBar v-if="alertaSubida==2"
                color="danger"
                :icon="mdiAlertCircle"
                :outline="notificationsOutline"
            >
                <b>Error</b>. <span v-text="mensajes"></span>
            </NotificationBar>
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 grid grid-cols-2 gap-2 sm:grid sm:grid-cols-2">

                        
                            <div class="card rounded-2xl dark:bg-slate-900/70 hover:shadow-lg transition-shadow duration-500 shadow-2xl md:mx-auto">
                                
                                <section class="card">
                                    <header class="card-header">
                                        <div class="card-actions">
                                            <a href="#" class="card-action card-action-toggle" data-card-toggle=""></a>
                                            <a href="#" class="card-action card-action-dismiss" data-card-dismiss=""></a>
                                        </div>
                                        <h2 class="card-title"><span class="numbercircle mr-1">1 </span> Tablas Simples</h2>
                                       
                                    </header>
                                    
                                    <div class="card-body">
                                        <div class="col-12 mb-2">
                                            <a href="/formats/catalogoimport.xlsx" target="_new" class="text-dark mr-auto"><span class="mr-2">Descargar formato</span> <i class="fa fa-download"></i></a>
                                        </div>
                                        <div class="col-sm-12 col-md-12 mb-2">
                                            
                                            
                                            <input type="file" id="fileCatalogo" ref="fileCatalogo" v-on:change="handleFileUploadArchivo" accept=".XLSX, .CSV" class="form-control mt-2">
                                        </div>
                                        <div class="col-sm-10 col-md-6 mt-2">
                                            <button v-on:click="eventSubirArchivo('/catalogo/importArchivo')" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Subir</button>
                                        </div>
                                        
                                    </div>
                                </section>
                               
                    
                                
                            </div>
                            <div class="card rounded-2xl dark:bg-slate-900/70 hover:shadow-lg transition-shadow duration-500 shadow-2xl md:mx-auto">
                                
                                <section class="card">
                                    <header class="card-header">
                                        <div class="card-actions">
                                            <a href="#" class="card-action card-action-toggle" data-card-toggle=""></a>
                                            <a href="#" class="card-action card-action-dismiss" data-card-dismiss=""></a>
                                        </div>
                                        <h2 class="card-title"><span class="numbercircle mr-1">2 </span>Estudiantes</h2>
                                        
                                    </header>
                                    
                                    <div class="card-body">
                                        <div class="col-12 mb-2">
                                            <a href="/formats/estudiantesimport.xlsx" target="_new" class="text-dark mr-auto"><span class="mr-2">Descargar formato</span> <i class="fa fa-download"></i></a>
                                        </div>
                                        <div class="col-12 form-group">
                                            <div class="col-sm-12 col-md-12 mb-2">
                                                
                                                
                                                <input type="file" id="fileEstudiante" ref="fileEstudiante" v-on:change="handleFileUploadArchivo" accept=".XLSX, .CSV" class="form-control mt-2">
                                            </div>
                                            <div class="col-sm-10 col-md-6 mt-2">
                                                <button v-on:click="eventSubirArchivo('/student/importArchivo')" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Subir</button>
                                            </div>
                                            
                                        </div>
                                       
                                    </div>
                                </section>
                            </div>
                        
                  
            </div>
        </div>-->
        <div>
            <div class="grid grid-cols-1 gap-8 sm:grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2">
                <NotificationBar v-if="alertaSubida == 4" color="contrast" :icon="mdiContrastCircle" :outline="notificationsOutline">
                    <b>Contrast</b>. NotificationBar
                </NotificationBar>
                <NotificationBar v-if="alertaSubida == 1" color="success" :icon="mdiCheckCircle" :outline="notificationsOutline">
                    <b>Ok</b>. <span v-text="mensajes"></span>
                </NotificationBar>
                <NotificationBar v-if="alertaSubida == 2" color="danger" :icon="mdiAlertCircle" :outline="notificationsOutline">
                    <b>Error</b>. <span v-text="mensajes"></span>
                </NotificationBar>
            </div>

            <div class="grid grid-cols-1 gap-8 sm:grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2">
                <!--<div class="row">-->
                <div class="xl:w-8/12 card rounded-2xl dark:bg-slate-900/70 hover:shadow-lg transition-shadow duration-500 shadow-2xl md:mx-auto">
                    <div class="flex flex-col -mb-6 -mt-6 -mr-6 -ml-6 animate-fade-in" is-placed-with-header="true">
                        <div class="card-head bg-rose-600 border-rose-600 text-white rounded-t-2xl flex flex-col p-6 transition-colors">
                            1 Tablas Simples
                            <!--<p class="card-subtitle">Máximo 50 registros por archivo, los campos son <b>sensibles</b> a espacios, <b>minúsculas y mayúsculas</b>.</p>-->
                        </div>
                        <div class="card-body p-6">
                            <div class="mb-6">
                                <a href="/formats/estudiantesimport.xlsx" target="_new" class="btn btn-rose btn-ico"><span class="mr-2">Descargar formato</span>
                                    <BaseIcon :path="mdiArrowDownBold" />
                                </a>
                            </div>
                            <div class="mb-8">
                                <label>
                                    <input type="file" id="fileCatalogo" ref="fileCatalogo" v-on:change="handleFileUploadArchivo" accept=".XLSX, .CSV" class="w-full input-file input-file-slate" />
                                </label>
                            </div>
                            <div class="mb-2">
                                <button v-on:click="eventSubirArchivo('/catalogo/importArchivo')" class="btn btn-rose">Subir</button>
                            </div>
                            <!--<button type="button" class="btn btn-primary m-xs" data-toggle="tooltip" data-placement="top" title="Tooltip on top">Top</button>
                                        <button type="button" class="btn btn-primary m-xs" data-toggle="tooltip" data-placement="right" title="Tooltip on right">Right</button>
                                        <button type="button" class="btn btn-primary m-xs" data-toggle="tooltip" data-placement="left" title="Tooltip on left">Left</button>
                                        <button type="button" class="btn btn-primary m-xs" data-toggle="tooltip" data-placement="bottom" title="Tooltip on bottom">Bottom</button>
                                        <a data-toggle="tooltip" title="Tooltip Link" href="#">Link</a>-->
                        </div>
                    </div>
                </div>
                <div class="xl:w-8/12 card rounded-2xl dark:bg-slate-900/70 hover:shadow-lg transition-shadow duration-500 shadow-2xl md:mx-auto">
                    <!-- Estudiantes -->
                    <div class="flex flex-col -mb-6 -mt-6 -mr-6 -ml-6 animate-fade-in" is-placed-with-header="true">
                        <div class="card-header bg-rose-600 border-rose-600 text-white rounded-t-2xl flex flex-col p-6 transition-colors">
                            Estudiantes
                            <!--<p class="card-subtitle">Máximo 50 registros por archivo, los campos son sensibles a espacios, minúsculas y mayúsculas.</p>-->
                        </div>

                        <div class="card-body p-6">
                            <div class="col-12 mb-6">
                                <a href="/formats/estudiantesimport.xlsx" target="_new" class="btn btn-rose btn-ico"><span class="mr-2">Descargar formato</span>
                                    <BaseIcon :path="mdiArrowDownBold" />
                                </a>
                            </div>

                            <div class="mb-8">
                                <label>
                                    <input type="file" id="fileEstudiante" ref="fileCatalogo" v-on:change="handleFileUploadArchivo" accept=".XLSX, .CSV" class="w-full input-file input-file-slate" />
                                </label>
                            </div>
                            <div class="mb-2">
                                <button v-on:click="eventSubirArchivo('/student/importArchivo')" class="btn btn-rose">Subir</button>
                            </div>
                            <!--<button type="button" class="btn btn-primary m-xs" data-toggle="tooltip" data-placement="top" title="Tooltip on top">Top</button>
                                        <button type="button" class="btn btn-primary m-xs" data-toggle="tooltip" data-placement="right" title="Tooltip on right">Right</button>
                                        <button type="button" class="btn btn-primary m-xs" data-toggle="tooltip" data-placement="left" title="Tooltip on left">Left</button>
                                        <button type="button" class="btn btn-primary m-xs" data-toggle="tooltip" data-placement="bottom" title="Tooltip on bottom">Bottom</button>
                                        <a data-toggle="tooltip" title="Tooltip Link" href="#">Link</a>-->
                        </div>
                    </div>

                </div>
                <!--</div>-->
            </div>

        </div>
    </BreezeAuthenticatedLayout>
</template>
